import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const TOKEN_KEY = 'loyalty_token';

export interface AuthUser {
  id: string;
  phone: string;
  userType: string;
  profile?: { fullName?: string };
}

interface AuthState {
  user: AuthUser | null;
  token: string | null;
  isAuthenticated: boolean;
  setAuth: (user: AuthUser, token: string) => void;
  logout: () => void;
  initFromStorage: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,

      setAuth: (user, token) => {
        if (typeof window !== 'undefined') {
          localStorage.setItem(TOKEN_KEY, token);
        }
        set({ user, token, isAuthenticated: true });
      },

      logout: () => {
        if (typeof window !== 'undefined') {
          localStorage.removeItem(TOKEN_KEY);
        }
        set({ user: null, token: null, isAuthenticated: false });
      },

      initFromStorage: () => {
        if (typeof window === 'undefined') return;
        const token = localStorage.getItem(TOKEN_KEY);
        if (token) {
          set({ token, isAuthenticated: true });
        } else {
          set({ user: null, token: null, isAuthenticated: false });
        }
      },
    }),
    { name: 'partner-auth', partialize: (s) => ({ token: s.token, user: s.user }) }
  )
);
